"use client";

import { Button } from "@/components/actions/Button";
import { useNav } from "@/providers/Nav";

export default function Nav() {
  const { navRetracted } = useNav();
  return (
    <nav
      className={`sticky  transition-all duration-300 ease-in-out ${navRetracted ? "top-0" : "top-[80px]"} z-[15000] bg-white py-6`}
    >
      <div className="contianer mx-auto flex justify-start md:justify-center gap-8 items-center overflow-auto px-gutter">
        <Button href="#stains" variant="secondary" isLight size="small">
          Stains
        </Button>
        <Button href="#paint" variant="secondary" isLight size="small">
          Paint
        </Button>
        <Button href="#laminates" variant="secondary" isLight size="small">
          Laminates
        </Button>
      </div>
    </nav>
  );
}
